"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icon_enum_1 = __importDefault(require("../../shared/enums/icon.enum"));
var classMap_1 = __importDefault(require("../../shared/utilities/classMap"));
var action_1 = __importDefault(require("../action"));
var avatar_1 = __importDefault(require("../avatar"));
var background_1 = __importDefault(require("../background"));
var enhanced_icon_1 = __importDefault(require("../enhanced-icon"));
var icon_1 = __importDefault(require("../icon"));
var progress_1 = __importDefault(require("../progress"));
var templates_1 = __importDefault(require("./templates"));
/**
 * Renders a visual action content component.
 * This is the lowest component of the hierarchy of visual action components, which consist of:
 * - VisualActionContainer
 * -- Visual Action
 * --- VisualActionContent
 * @param {VisualActionContentProps} props - The props for the VisualActionContent component.
 * @returns {JSX.Element} The rendered VisualActionContent component.
 */
function VisualActionContent(props) {
    var _a, _b;
    var templateProps = {
        title: props.title,
        titleClassName: props.titleClassName,
        slogan: props.slogan,
        avatar: props.avatar && react_1.default.createElement(avatar_1.default, __assign({}, props.avatar)),
        icon: props.icon && react_1.default.createElement(enhanced_icon_1.default, __assign({}, props.icon)),
        image: props.image && props.image !== "" ? react_1.default.createElement("img", { src: props.image, alt: props.title }) : "",
        titleHTMLTag: props.titleHTMLTag,
        background: props.background && react_1.default.createElement(background_1.default, __assign({}, props.background, { className: "position-relative w-100" })),
        action: props.action && react_1.default.createElement(action_1.default, __assign({}, props.action)),
        progress: props.progress && react_1.default.createElement(progress_1.default, __assign({}, props.progress)),
        description: props.description,
        meta: props.meta && (react_1.default.createElement("a", { href: (_a = props.meta) === null || _a === void 0 ? void 0 : _a.url, target: "_blank", rel: "noopener noreferrer", onClick: function (e) {
                var _a;
                if (typeof ((_a = props.meta) === null || _a === void 0 ? void 0 : _a.resourceClickCallback) === "function") {
                    props.meta.resourceClickCallback(window.location.href);
                }
                e.stopPropagation();
            } },
            react_1.default.createElement(icon_1.default, { icon: icon_enum_1.default.GUIDED_NOTES }),
            react_1.default.createElement("span", null, (_b = props.meta) === null || _b === void 0 ? void 0 : _b.text))),
        descriptionClassName: props.descriptionClassName
    };
    return (react_1.default.createElement("div", { className: (0, classMap_1.default)("mpng-ux-visual-action-content", props.className, "d-flex", "h-100 m-0") }, (props.template && templates_1.default[props.template](templateProps)) || templates_1.default.Standard(templateProps)));
}
exports.default = VisualActionContent;
